
import Container from 'react-bootstrap/Container'
import React, { useEffect, useState } from "react";
import { faLeftRight } from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Routes, Route } from "react-router";


import MapPage from './components/pages/MapPage';
import HomePage from './components/pages/FaqPage';
import AdminPage from './components/pages/AdminPage';
import CallbackPage from './components/pages/CallbackPage';
import NotFoundPage from './components/pages/NotFoundPage ';
import FaqPage from './components/pages/FaqPage';
import SubscriptionPage from './components/pages/SubscriptionPage'
import MapGlPage from './components/pages/MapGlPage'
import Login from "./components/firebase-auth/login";
import Register from "./components/firebase-auth/register";
import PasswordReset from "./components/firebase-auth/password-reset"
//import Home from "./components/home";

import { AuthProvider } from "./contexts/authContext";
import { useRoutes, useLocation } from "react-router";
import { ErrorBoundary } from './components/ErrorBoundary';
import { trackPageView } from './firebase/telemetry';

import { AuthenticationGuard } from './components/auth/AuthenticationGuard'
import { SubscriptionGaurd } from './components/auth/SubscriptionGaurd';
import { BetaGuard, BETA_BUILD } from './components/auth/BetaGuard';
import TermsPage from './components/pages/TermsPage';
import PrivacyPage from './components/pages/PrivacyPage';
import { AdminGaurd } from './components/auth/AdminGaurd';


function App() {
    const routesArray = [

      {
        path: "/",
        // On the develop build the map sits behind BetaGuard as well, so a
        // paying customer who follows a stale link is told where to go rather
        // than dropped into an unreleased build. BETA_BUILD is false in the
        // production bundle, so this is the plain SubscriptionGaurd there.
        element: BETA_BUILD
          ? <BetaGuard component={() => <SubscriptionGaurd component={MapGlPage} />} />
          : <SubscriptionGaurd component={MapGlPage} />,
      },
      {
        path: "/terms",
        element: <TermsPage />
      },
      {
        path: "/privacy",
        element: <PrivacyPage />
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/password-reset",
        element: <PasswordReset />,
      },
      {
        path: "/faq",
        element: <FaqPage/>
      },
      {
        path: "/signup",
        element: <Register />,
      },
      {
        path:"/subscribe",
        element: <AuthenticationGuard component={SubscriptionPage} />,
      },
      {
        path:"/admin",
        element: <AdminGaurd component={AdminPage}/>
      }
    ];
    let routesElement = useRoutes(routesArray);

    // GA4 only auto-fires page_view on route change when Enhanced Measurement's
    // "page changes based on browser history events" is on. Logging it here
    // makes /login, /subscribe and /admin visible regardless of that setting.
    const location = useLocation();
    useEffect(() => {
      trackPageView(location.pathname);
    }, [location.pathname]);

    return (
      <ErrorBoundary name="App">
        <AuthProvider>
          {routesElement}
        </AuthProvider>
      </ErrorBoundary>
    );
  }

export default App;